/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import QueryProviderClient from '@fe-news/context/query-provider';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import NewsSearchListSkeleton from './NewsSearchListSkeleton';

/**
 *  新聞關鍵字/標籤搜尋列表
 *  /search?q=xxx 頁面元件
 *  /tag/[tag] 頁面元件
 */
const DynamicNewsSearchList = dynamic(() => import('./NewsSearchList'), {
  loading: () => <NewsSearchListSkeleton />,
  ssr: false
});

const DynamicLoadNewsSearchList = (props: any) => {
  return (
    <Suspense>
      <QueryProviderClient>
        <DynamicNewsSearchList {...props} />
      </QueryProviderClient>
    </Suspense>
  )
}

export default DynamicLoadNewsSearchList;
